import { setActiveModal } from "@/store";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Modal, Text, Button, Group } from "@mantine/core";

export const ProgressLostModal = ({ onConfirm }: { onConfirm: () => void }) => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.oos.activeModal === "progressLost",
  );

  const handleCancel = () => {
    dispatch(setActiveModal(null));
  };

  return (
    <Modal
      opened={isOpen}
      onClose={handleCancel}
      title="Warning: Progress Will Be Lost"
      centered
      withinPortal={false}
    >
      <Text size="sm" mb="lg" className="text-left">
        You will lose your current progress by switching reference images.
        Continue?
      </Text>

      <Group justify="flex-end" gap="sm">
        <Button variant="outline" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            dispatch(setActiveModal(null));
          }}
        >
          Continue
        </Button>
      </Group>
    </Modal>
  );
};
